import { CanDeactivateFn } from '@angular/router';
import type { CrearFacturaComponent } from './crear-factura.component';

export const crearFacturaCanDeactivate: CanDeactivateFn<CrearFacturaComponent> = (component) => {
  return component.confirmarSalidaSiDatosPendientes();
};
